module.exports = __webpack_public_path__ + "static/media/baccaret.f98e6e4c.webp";